<template>
    <div class="main">
        <div class="hotnews_box">
            <div class="content crumbs">
                <span class="iconfont icon-dingwei"></span>
                <b>当前位置：</b>
                <a href="/">首页</a>
                <a
                    href="/bidopening-site"
                    class="cur"
                >开标现场</a>
            </div>
        </div>

        <div
            class="content"
            style="padding:60px 0px 40px 0px"
        >
            <div class="title">开标现场</div>
            <div class="site">
                <div
                    class="item"
                    v-for="(item,index) in data"
                    :key="item.guid"
                    @click="openDialog(item)"
                >
                    <img :src="img[index]" />
                    <div class="name">{{item.cameraname}}</div>
                </div>

            </div>
        </div>
        <el-dialog
            title="开标现场视频"
            :visible.sync="dialogVisible"
            :width="'900px'"
        >
            <iframe
                width="860px"
                height="484px"
                :src="currentRow.playurl1"
                align="middle"
                allowScriptAccess="sameDomain"
                type="application/x-shockwave-flash"
            ></iframe>
        </el-dialog>
    </div>

</template>

<script>
import CONFIG from '@config/config';

export default {
    data() {
        return {
            data: [],
            img: [
                '/images/kbxc1.jpg',
                '/images/kbxc2.jpg',
                '/images/kbxc3.jpg',
            ],
            dialogVisible: false,

            currentRow: {},
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        openDialog(item) {
            this.currentRow = item;
            this.dialogVisible = true;
        },
        init() {
            this.$get(
                '/venuereservationapi/api/web/cameraInfos.json',
                {
                    jyptcode: CONFIG.head.planname,
                },
                (data) => {
                    this.data = data.slice(0, 3);
                }
            );
        },
    },
};
</script>
<style lang='scss' scoped>
.main {
    .hotnews_box {
        box-shadow: 1px 0px 5px #dedede;
        height: 46px;
        line-height: 46px;
        background-color: #ffffff;

        .crumbs {
            font-size: 16px;
            user-select: none;
            span {
                display: inline-block;
                margin-bottom: 2px;
                margin-left: 15px;
                padding: 0 0 0 20px;
                height: 21px;
                background: url(/images/map.jpg) no-repeat center 0;
                vertical-align: middle;
                margin-right: 5px;
            }
            b {
                color: #181818;
                font-weight: normal;
            }
            a {
                padding-right: 20px;
                background: url(/images/r-arrow.png) no-repeat right center;
                color: #181818;
                text-decoration: none;
                font-weight: 400;
                &:last-child {
                    background: 0 0;
                }
            }

            .cur {
                color: #d1171e;
            }
        }
    }

    .title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }

    .site {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .item {
            width: 31.3%;
            text-align: center;
            cursor: pointer;
            .name {
                font-size: 18px;
                line-height: 50px;
                color: #333;
            }
        }
        img {
            width: 100%;
        }
    }
}
</style>
